import React from 'react'
import PropTypes from 'prop-types'
import css from './UserCard.module.css'
import SunIcon from '../icons/sun'
import MoonIcon from '../icons/moon'

const UserCardLocalTime = ({ children, night, ...props }) => {
  const icon = night ? <MoonIcon /> : <SunIcon />
  return (
    <div className={css.localTime}>{icon} Local time: {children}</div>
  )
}

UserCardLocalTime.displayName = 'UserCardLocalTime'

UserCardLocalTime.propTypes = {
  night: PropTypes.bool
}

export default UserCardLocalTime



// WEBPACK FOOTER //
// ./components/Customers/presentational/UserCardLocalTime.js